import React, { useState } from "react";
import remove from "lodash/remove";

import { VacancyPageContext } from "../contexts/vacancyPageContext";
import { useEventListener } from "../hooks/useEventListener";
import { EVENT_TOPICS } from "../utilities/eventUtils";

const VacancyPageContextProvider = ({ children }) => {
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState();
  const [totalPages, setTotalPages] = useState();
  const [vacancies, setVacancies] = useState();
  const [singleVacancy, setSingleVacancy] = useState();

  useEventListener(
    EVENT_TOPICS.ON_VACANCY_DELETED,
    ({ deletedVacancyId }) => {
      const copiedData = [...vacancies];
      remove(copiedData, (item) => item.id === deletedVacancyId);

      setVacancies(copiedData);
      setTotalRecords((prev) => Math.max((prev ?? 1) - 1, 0));
    },
    [vacancies]
  );

  useEventListener(
    EVENT_TOPICS.ON_VACANCY_UPDATED,
    ({ updatedVacancy }) => {
      setSingleVacancy((prev) => ({ ...prev, ...updatedVacancy }));
    },
    [singleVacancy]
  );

  return (
    <VacancyPageContext.Provider
      value={{
        vacancies,
        setVacancies,
        singleVacancy,
        setSingleVacancy,
        currentPage,
        setCurrentPage,
        totalPages,
        setTotalPages,
        totalRecords,
        setTotalRecords,
        pageSize,
        setPageSize,
      }}
    >
      {children}
    </VacancyPageContext.Provider>
  );
};

export default VacancyPageContextProvider;
